import TransferErrorScreen from 'features/feeBasedInstantTransfer/screens/TransferError/TransferErrorScreen';

export default function InstantTransferErrorPage() {
  return <TransferErrorScreen />;
}
